import { THEME } from 'bora-material-ui/themes'

export const isLiinilaevad = window.brandProps.theme === THEME.LIINILAEVAD

export const getStyle = (style, defaultStyle) => (isLiinilaevad ? style : defaultStyle)
